import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {MessageService} from 'primeng/api';
import {catchError, EMPTY, throwError} from 'rxjs';

export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 0) {
        messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail: 'Não foi possível obter conexão com o servidor. Tente novamente em alguns instantes.',
          life: 6000
        });
        return EMPTY;
      }
      return throwError(() => err);
    })
  );
};
